import MachineRegister from "@/pages/machine/register";
import { Routes } from "./routes";
import MachineList from "@/pages/machine/list";
import MachineModify from "@/pages/machine/modify";
import CollectionDataSet from "@/pages/collectionDataSet";
import UserProfile from "@/pages/userProfile/list";
import UserManagement from "@/pages/userManagement";
import Dashboard from "@/pages/dashboard";
import TrendExpand from "@/pages/trendExpand";

export const AuthenticatedPath = [
  { path: Routes.MACHINE_LIST, element: <MachineList /> },
  {
    path: Routes.MACHINE_REGISTER,
    element: <MachineRegister />,
  },
  { path: Routes.MACHINE_MODIFY, element: <MachineModify /> },
  {
    path: Routes.COLLECTION_DATA_SET,
    element: <CollectionDataSet />,
  },
  { path: Routes.USER_PROFILE, element: <UserProfile /> },
  { path: Routes.USER_MANAGEMENT, element: <UserManagement /> },
  { path: Routes.DASHBOARD, element: <Dashboard /> },
  { path: Routes.TREND_EXPAND, element: <TrendExpand /> },
];
